<template>
	<div class="main_sku">
		<el-table
			:data="skuTableData"
			border
			style="width:100%;"
			max-height="600"
			:cell-style="tc"
			:header-cell-style="tccolor"
		>
			<el-table-column label="SKU编号" prop="id"> </el-table-column>
			<el-table-column label="SKU属性">
				<template slot-scope="scope">
					<div v-if="scope.row.product_sku_attribute">
						<p v-for="item in scope.row.product_sku_attribute" :key="item.id">
							{{ item.attr_name }} : {{ item.attr_value }}
						</p>
					</div>
					<div v-else>---</div>
				</template>
			</el-table-column>
			<el-table-column label="成本价格">
				<template slot-scope="scope">
					<p v-if="scope.row.cost_price">¥ {{ scope.row.cost_price }}</p>
					<p v-else>---</p>
				</template>
			</el-table-column>
			<el-table-column label="供货价">
				<template slot-scope="scope">
					<p v-if="scope.row.supply_price">¥ {{ scope.row.supply_price }}</p>
					<p v-else>---</p>
				</template>
			</el-table-column>
			<el-table-column label="建议售价">
				<template slot-scope="scope">
					<p v-if="scope.row.sale_price">¥ {{ scope.row.sale_price }}</p>
					<p v-else>---</p>
				</template>
			</el-table-column>
			<el-table-column label="库存数">
				<template slot-scope="scope">
					<p v-if="scope.row.inventory">
						{{ scope.row.inventory }}
					</p>
					<p v-else>---</p>
				</template>
			</el-table-column>
			<el-table-column label="SKU图片">
				<template slot-scope="scope">
					<img
						v-if="scope.row.img_url"
						style="width:36px;height:36px;object-fit:cover;"
						:src="scope.row.img_url"
						alt
					/>
					<p v-else>(无)</p>
				</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right">
				<template slot-scope="scope">
					<div
						class="buy"
						@click="
							buySkugoods(
								scope.row.id,
								scope.row.product_sku_attribute,
								scope.row.supply_price
							)
						"
					>
						采购
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { skusProduct } from '@/api/goods'
export default {
	// props: ['goodsId', 'visible'],
	props: {
		visible: { type: Boolean, default: () => false },
		goodsId: { type: String, default: () => '' }
	},
	data() {
		return {
			skuTableData: [],
			page: 1,
			size: 20,
			total: 0
		}
	},
	watch: {
		goodsId(newValue) {
			if (newValue) {
				this.skusProductData()
			}
		}
	},

	methods: {
		//获取商品sku
		async skusProductData() {
			let res = await skusProduct(this.goodsId, {
				page: this.page,
				size: this.size
			})
			this.skuTableData = res
			this.total = res.total
		},
		// 采购sku
		buySkugoods(id, attribute, supply_price) {
			this.$emit('bugSkuGoods', {
				id: id,
				attribute: attribute,
				supply_price: supply_price
			})
		},
		tc() {
			return 'text-align:center; color:#333333; font-size:12px;'
		},
		tccolor() {
			return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
		}
	}
}
</script>

<style lang="scss" scoped>
.main_sku {
	padding: 20px;

	.buy {
		cursor: pointer;
		font-size: 13px;
		color: rgb(253, 152, 64);
	}
}
</style>
